"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleComponent = void 0;
const react_1 = __importDefault(require("react"));
const exampleComponent_css_1 = require("./exampleComponent.css");
const ExampleComponent = ({ exampleProp }) => (react_1.default.createElement("h1", { className: exampleComponent_css_1.exampleComponentTitle },
    "Web Plugin Template (example component)",
    ' ',
    exampleProp));
exports.ExampleComponent = ExampleComponent;
